import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const DispatchShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Dispatch Section"
    sectionKey="Dispatch"
    backRoute="/sections/dispatch"
  />
);

export default DispatchShipmentRequest;
